import { render, staticRenderFns } from "./RecentTransactions.vue?vue&type=template&id=832c1b1c"
import script from "./RecentTransactions.vue?vue&type=script&lang=js"
export * from "./RecentTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports